import React, { Component } from 'react';
import PropTypes from 'prop-types';

import defaultImg  from '../../../assets/images/news.png';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class NewsItem extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            textPreview: 'show',
            textFull: 'hide'
        }
    }

    setDefaultImg = (e) => {
        e.target.src = defaultImg;
    }

    createMarkupTextPreview = () => {
        return {__html: this.props.news.textPreview};
    }

    createMarkupTextFull = () => {
        return {__html: this.props.news.textFull};
    }
   
    render() { 
        let image = <img onError={this.setDefaultImg} referrerPolicy="no-referrer"
                    src={`/api/welsend/public/news/${this.props.news.newsId}/file`} 
                    className="news-image" alt={`img_${this.props.news.newsId}`}/>                      
                             
        let showTextFull = '';
        let hideTextPreview = '';
        if (this.props.active) {
            showTextFull = 'show',
            hideTextPreview = 'hide'
        }

        return (
         <div className='item-news'>
             <div className='item-news-img'>
                {image}
            </div>
            <div>
                <div className='date'>{this.props.news.publicationDate}</div>
                <div className='title'>{this.props.news.name}</div>
                <div className={`textPreview ${hideTextPreview}`}>
                    <div dangerouslySetInnerHTML={this.createMarkupTextPreview()} />
                    <button className='show news-btn' onClick={() => 
                        this.props.showFullText(this.props.news.newsId)}>
                            {translateStaticContent('newsBtnShow', 
                                this.props.defaultStaticContentNews, this.props.activeLangStaticContentNews)}
                    </button>
                </div>
                <div className={`textFull ${showTextFull}`}>
                <div dangerouslySetInnerHTML={this.createMarkupTextFull()} />
                    <button className='hide news-btn' 
                        onClick={() => this.props.hidePreviewText()}>
                        {translateStaticContent('newsBtnHide', 
                            this.props.defaultStaticContentNews, this.props.activeLangStaticContentNews)}
                    </button>
                </div>
            </div>
         </div>
        )
    }
}

export default NewsItem;

NewsItem.propTypes = {
    news: PropTypes.object.isRequired,
    showFullText: PropTypes.func.isRequired,
    hidePreviewText: PropTypes.func.isRequired,
    active: PropTypes.bool.isRequired,
    defaultStaticContentNews: PropTypes.object,
    activeLangStaticContentNews: PropTypes.object,
}